import { ShieldAlert } from 'lucide-react';

export const WorkflowAccessDenied = ({ permission = 'workflow.view' }: { permission?: string }) => (
  <div className="flex flex-col items-center justify-center gap-3 rounded-xl border border-gray-100 bg-white py-20 text-center shadow-sm">
    <div className="flex h-14 w-14 items-center justify-center rounded-full bg-red-50">
      <ShieldAlert className="h-7 w-7 text-red-500" />
    </div>
    <h2 className="text-lg font-semibold text-gray-800">Access restricted</h2>
    <p className="max-w-sm text-sm text-gray-500">
      This page requires the{' '}
      <code className="rounded bg-gray-100 px-1.5 py-0.5 text-xs">{permission}</code> permission.
    </p>
  </div>
);

export const formatDateTime = (raw?: string | null) => {
  if (!raw) return '—';
  try {
    return new Date(raw).toLocaleString('en-GB', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
  } catch {
    return raw;
  }
};

export const formatDuration = (ms?: number | null) => {
  if (ms == null || Number.isNaN(ms)) return '—';
  if (ms < 1000) return `${Math.round(ms)}ms`;
  if (ms < 60_000) return `${(ms / 1000).toFixed(1)}s`;
  return `${(ms / 60_000).toFixed(1)}m`;
};

export const statusBadgeClass = (status: string) => {
  switch (status) {
    case 'success':
    case 'published':
    case 'safe':
    case 'enqueued':
      return 'bg-emerald-50 text-emerald-700 border-emerald-100';
    case 'error':
    case 'rejected':
    case 'failed':
      return 'bg-red-50 text-red-700 border-red-100';
    case 'waiting':
    case 'human_review':
    case 'age_restricted':
      return 'bg-amber-50 text-amber-700 border-amber-100';
    case 'unavailable':
    case 'not_found':
      return 'bg-gray-100 text-gray-600 border-gray-200';
    default:
      return 'bg-slate-50 text-slate-700 border-slate-100';
  }
};

export const getApiErrorCode = (error: unknown): string | undefined => {
  const err = error as {
    data?: { error?: string; data?: { error?: string } };
    response?: { data?: { error?: string; data?: { error?: string } } };
  };
  return (
    err?.data?.data?.error ??
    err?.data?.error ??
    err?.response?.data?.data?.error ??
    err?.response?.data?.error
  );
};

export const isN8nUnconfigured = (error: unknown) => getApiErrorCode(error) === 'n8n_unconfigured';
